export const AUTHORIZATION_TOKEN = 'AUTHORIZATION_TOKEN';
export const LANGUAGE = 'LANGUAGE';
export const SLIDE_VIEWER_SIDEBAR_OPEN = 'SLIDE_VIEWER_SIDEBAR_OPEN';
export const SELECTED_PERIOD_ID = 'SELECTED_PERIOD_ID';
